module.exports = __webpack_public_path__ + "img/13200.b7c636a1.jpg";